import BulkOrderConfirmPage from '../../../../customer/components/pages/bulk_order/confirm/BulkOrderConfirmPage.vue'

export default {
  components: { BulkOrderConfirmPage }
}
